import { api } from '../../lib/api';
import type { CallLogRow } from '../../types/leadCall';
import type { KyckConnectSetupResponse, KyckConnectSummaryResponse, SummaryDays } from '../../types/kyckConnect';
import type { Grouping } from '../../lib/kyckConnect/metrics';
import type { KyckConnectReport, ReportMonths } from '../../types/kyckConnectInsights';

// The staff KyckConnect API (redesign Phase 1). Read-only.

const BASE = '/api/kyckconnect';

export const fetchSetup = (accountId: string) => api<KyckConnectSetupResponse>(`${BASE}/accounts/${encodeURIComponent(accountId)}/setup`);
export const fetchSummary = (accountId: string, days: SummaryDays) =>
  api<KyckConnectSummaryResponse>(`${BASE}/accounts/${encodeURIComponent(accountId)}/summary?days=${days}`);

export interface AllCallsPageResponse {
  calls: Array<{ accountId: string | null; row: CallLogRow }>;
  nextCursor: string | null;
}
/** The all-clients call log (admin only without an accountId; the server decides). */
export const fetchAllCalls = (accountId: string | null, cursor: string | null) => {
  const q = new URLSearchParams();
  if (accountId) q.set('accountId', accountId);
  if (cursor) q.set('cursor', cursor);
  const qs = q.toString();
  return api<AllCallsPageResponse>(`/api/speed-to-lead/calls${qs ? `?${qs}` : ''}`);
};

export interface StaffReportFilters {
  accountId?: string | null;
  brandId?: string | null;
  groupId?: string | null;
  months: ReportMonths;
  grouping: Grouping;
  compare: boolean;
}
/** The staff report: one club for any staff, everything else admin only (the server decides). */
export const fetchStaffReport = (f: StaffReportFilters) => {
  const q = new URLSearchParams({ months: String(f.months), grouping: f.grouping, compare: f.compare ? '1' : '0' });
  if (f.accountId) q.set('accountId', f.accountId);
  if (f.brandId) q.set('brandId', f.brandId);
  if (f.groupId) q.set('groupId', f.groupId);
  return api<KyckConnectReport>(`${BASE}/report?${q.toString()}`);
};
